import { lazy } from "react";

const MyPagePassword = lazy(() => import("app/pages/mypage/MyPagePassword"));
const MyPageDetail = lazy(() => import("app/pages/mypage/MyPageDetail"));

export const mpRouter: any[] = [
  {path: 'mypage', element: <MyPagePassword />},
  {path: 'mypage/:type?', element: <MyPageDetail />},
];